import { buoysAPI } from '../common/api/buoys';

export default { path: buoysAPI.reducerPath, reducer: buoysAPI.reducer };
